import { cn } from "@/lib/utils";

export function PageHeader({ eyebrow, title, subtitle, action, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 fade-up" data-testid={testid}>
      <div>
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.25em] text-brand font-mono mb-3 flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-brand pulse-dot" />
            {eyebrow}
          </div>
        )}
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-[0.95]">{title}</h1>
        {subtitle && <p className="text-white/50 mt-3 max-w-xl text-sm leading-relaxed">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function ScorePill({ value, label }) {
  const color = value >= 75 ? "text-signal-green" : value >= 50 ? "text-signal-yellow" : "text-white/50";
  return (
    <div className="flex flex-col">
      <span className={cn("font-mono text-2xl tracking-tight", color)}>{value}</span>
      {label && <span className="text-[10px] uppercase tracking-[0.15em] text-white/30 font-mono mt-0.5">{label}</span>}
    </div>
  );
}

const statusMap = {
  draft: { c: "text-white/50 border-white/15 bg-white/5", l: "Draft" },
  ready: { c: "text-signal-yellow border-signal-yellow/30 bg-signal-yellow/10", l: "Ready" },
  uploaded: { c: "text-signal-green border-signal-green/30 bg-signal-green/10", l: "Uploaded" },
};
export function StatusBadge({ status }) {
  const s = statusMap[status] || statusMap.draft;
  return (
    <span className={cn("text-[10px] uppercase tracking-[0.15em] font-mono px-2 py-1 rounded border", s.c)}>{s.l}</span>
  );
}

const momentumMap = {
  rising: { c: "text-signal-green border-signal-green/30", l: "↗ Rising" },
  emerging: { c: "text-signal-blue border-signal-blue/30", l: "◆ Emerging" },
  peaking: { c: "text-brand border-brand/30", l: "▲ Peaking" },
};
export function MomentumBadge({ momentum }) {
  const m = momentumMap[momentum] || momentumMap.rising;
  return <span className={cn("text-[10px] uppercase tracking-[0.12em] font-mono px-2 py-1 rounded border", m.c)}>{m.l}</span>;
}

export function Loader({ label = "Working" }) {
  return (
    <div className="flex items-center gap-3 text-white/40 font-mono text-sm py-12 justify-center" data-testid="loader">
      <span className="inline-block w-2 h-2 bg-brand pulse-dot rounded-full" />
      <span className="tracking-wider">{label}<span className="animate-pulse">...</span></span>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="border border-dashed border-white/10 rounded-md p-12 text-center flex flex-col items-center gap-3" data-testid="empty-state">
      {Icon && <Icon className="w-8 h-8 text-white/20" strokeWidth={1.25} />}
      <div className="font-heading text-lg text-white/80">{title}</div>
      {hint && <p className="text-white/40 text-sm max-w-sm">{hint}</p>}
      {action}
    </div>
  );
}
